declare var LiveAgent: any;

export default {
    install(Vue, options) {
        Vue.LOAD_LIVE_AGENT_BUTTON = true;
        Vue.mixin({
            created() {
                if (Vue.LOAD_LIVE_AGENT_BUTTON) {
                    Vue.LOAD_LIVE_AGENT_BUTTON = false;
                    const divBlock = document.createElement('div');
                    divBlock.id = 'chatButton';
                    document.body.appendChild(divBlock);

                    const scriptUrl = 'https://hococo.ladesk.com/scripts/track.js';
                    const node = document.createElement('script');
                    node.src = scriptUrl;
                    node.id = 'la_x2s6df8d';
                    node.type = 'text/javascript';
                    node.async = true;
                    node.charset = 'utf-8';
                    node.onload = (e) => {
                        Vue.prototype.$liveAgentButton = LiveAgent.createButton('5r8hnvoh', document.getElementById('chatButton'));
                    };
                    document.getElementsByTagName('head')[0].appendChild(node);
                }
            },
        });
    },
};
